import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useTheme } from '@material-ui/core/styles';

import { setPortal } from 'modules/portal';
import { showSuccessSnackbar } from 'modules/snackbar';
import { creativeListAbTest } from 'lib/api/creative';
import {
  getHeadObj,
  makeRowColumn,
  dataConverter,
  converParameters,
} from 'lib/commonLib';
import { withRouter } from 'react-router';
import { userOnLogin } from 'lib/api/user';

import { displayFilterList } from 'constants/resources/commonCustomize';

import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const AbTest = (props) => {
  const { devLocation, location } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };
  const [initialization, setInitialization] = useState(false);
  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    pltfomTpCode: 'all',
  };
  const convertKeys = ['mobonAdGrpId', 'adverIds', 'sDate', 'eDate'];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };
  const [params, setParams] = useState(initParams);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    SESSION_ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'SESSION_ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'SESSION_ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'SESSION_ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <p style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(
                rowObj['SESSION_ROAS'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </p>
          </>
        );
      },
      orderFlag: false,
    },
    SESSION_ROAS: { merged: true },
    DIRECT_ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'DIRECT_ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'DIRECT_ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <p style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(
                rowObj['DIRECT_ROAS'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </p>
          </>
        );
      },
      orderFlag: false,
    },
    DIRECT_ROAS: { merged: true },
    ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <p style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(rowObj['ROAS'], bodyItem2.type, bodyItem2.format)}
            </p>
          </>
        );
      },
      orderFlag: false,
    },
    ROAS: { merged: true },
    KPI_NO: { merged: true },
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (rowObj) => {
        return (
          rowObj['GRP_NAME'] !== 'total' && (
            <NewButton
              title={t('광고주 로그인')}
              iconBtn
              icon="faSignInAlt"
              disableRipple
              onClick={(e) => handleOnLogin(rowObj)}
            />
          )
        );
      },
    });
    return result;
  })();

  const handleOnLogin = (rowData) => {
    const showWindowUrl = converParameters({
      url: devLocation + '/creative/abtest_manage',
      kpiNo: rowData['KPI_NO'],
      kpiNm: rowData['KPI_NM'],
      loadingType: 'admin',
    });
    userOnLogin(params.adverIds, 'manage', showWindowUrl)
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          handleClickSnackbar({
            message: t('로그인에 실패했습니다. 관리자에게 문의하세요.'),
            option: {
              type: 'error',
            },
          });
        }
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      });
  };

  const makeSubParam = (data) => {
    return {
      adverId: data.ADVER_ID,
    };
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          displayFilterList={displayFilterList.creative}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={creativeListAbTest}
        makeSubParam={makeSubParam}
        customized={customized}
        useFetch={false}
        usePagenation={false}
        useTotal={false}
        addColumnList={addColumnList}
      />
    </>
  );
};
export default withRouter(AbTest);
